// extracted by mini-css-extract-plugin
export default {"gridClass":"style-module--gridClass--AWgg-","section":"style-module--section--XYpQA"};